(() => {
  const rootUrl = window.Shopify?.routes?.root || '/';
  const normalize = text => (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const panels = [...document.querySelectorAll('.flags-preview')];
  const updatePreviewImage = () => {
    const panel = panels.find(p => '#' + p.id === location.hash);
    const image = panel?.querySelector('[data-sales-image-src]');
    if (image && !image.getAttribute('src')) image.src = image.dataset.salesImageSrc;
  };
  updatePreviewImage();
  window.addEventListener('hashchange', updatePreviewImage);

  const search = document.querySelector('[data-sales-search]');
  const availableFilter = document.querySelector('[data-sales-available-filter]');
  const cards = [...document.querySelectorAll('.flags-world__card')];
  const applyFilters = () => {
    const term = normalize(search?.value);
    cards.forEach(card => { card.hidden = !normalize(card.textContent).includes(term) || (availableFilter?.checked && card.dataset.salesAvailable !== 'true'); });
    document.querySelectorAll('.flags-world__group').forEach(group => { group.hidden = !group.querySelector('.flags-world__card:not([hidden])'); });
    const count = cards.filter(card => !card.hidden).length;
    const status = document.querySelector('[data-sales-results]');
    if (status) status.textContent = count ? count + ' modèle' + (count > 1 ? 's' : '') + ' affiché' + (count > 1 ? 's' : '') : 'Aucun modèle dans cette sélection. Décoche le filtre ou modifie ta recherche.';
  };
  search?.addEventListener('input', applyFilters);
  availableFilter?.addEventListener('change', applyFilters);
  if (cards.length) applyFilters();

  const kit = document.querySelector('[data-sales-kit]');
  if (kit) {
    const flag = kit.querySelector('[data-sales-flag]');
    const pops = kit.querySelector('[data-sales-pops]');
    const belt = kit.querySelector('[data-sales-belt]');
    const submit = kit.querySelector('[data-sales-kit-submit]');
    const status = kit.querySelector('[data-sales-kit-status]');
    const price = kit.querySelector('[data-sales-kit-total]');
    const summary = kit.querySelector('[data-sales-kit-summary]');
    const image = kit.querySelector('[data-sales-kit-image]');
    const currency = kit.dataset.currency || 'EUR';
    const kitDiscount = Number(kit.dataset.kitDiscount || 0);
    const discountLine = kit.querySelector('[data-sales-kit-discount]');
    const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(cents / 100);
    panels.forEach(panel => {
      const handle = panel.id.replace('preview-', '');
      if ([...flag.options].some(o => o.dataset.handle === handle)) return;
      const option = document.createElement('option');
      option.value = 'preview:' + handle;
      option.dataset.handle = handle;
      option.dataset.preview = 'true';
      option.dataset.price = panel.dataset.salesPrice || '1400';
      option.dataset.label = panel.querySelector('h2').textContent.trim();
      const art = panel.querySelector('.flags-preview__art img');
      option.dataset.image = art?.dataset.salesImageSrc || art?.getAttribute('src') || '';
      option.textContent = option.dataset.label + ' — ' + money(Number(option.dataset.price)) + ' · Aperçu, non publié';
      flag.appendChild(option);
    });
    let busy = false;
    const selected = () => [flag, pops, belt].map(select => select.value ? select.selectedOptions[0] : null);
    const update = () => {
      const list = selected();
      const complete = list.every(o => o && !o.disabled);
      const preview = list[0]?.dataset.preview === 'true';
      summary.replaceChildren();
      list.forEach((o, i) => {
        const item = document.createElement('li');
        item.textContent = ['Flags : ', 'Pops : ', 'Ceinture : '][i] + (o ? (o.dataset.label || o.textContent).split(' — ')[0] : 'à choisir');
        summary.appendChild(item);
      });
      const gross = list.reduce((sum, o) => sum + (o ? Number(o.dataset.price) : 0), 0);
      price.textContent = complete ? money(Math.max(0, gross - kitDiscount)) : '—';
      if (discountLine) discountLine.hidden = !(complete && kitDiscount > 0);
      image.hidden = !list[0]?.dataset.image;
      if (!image.hidden) { image.src = list[0].dataset.image; image.alt = list[0].dataset.label || 'Flags sélectionnés'; }
      if (!busy) {
        submit.disabled = !complete || preview;
        submit.textContent = preview ? 'MODÈLE NON PUBLIÉ · APERÇU UNIQUEMENT' : complete ? 'AJOUTER LES 3 ARTICLES AU PANIER' : 'CHOISIS LES 3 COMPOSANTS';
        status.textContent = preview ? 'Tu peux composer et chiffrer ce kit, mais ce flag n’est pas encore en vente.' : '';
      }
    };
    [flag, pops, belt].forEach(select => select.addEventListener('change', update));
    const chooseFlag = handle => {
      const option = [...flag.options].find(o => o.dataset.handle === handle && !o.disabled);
      if (option) { flag.value = option.value; update(); }
    };
    if (kit.dataset.currentHandle) chooseFlag(kit.dataset.currentHandle);
    update();
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-sales-kit-for]');
      if (!trigger) return;
      event.preventDefault();
      chooseFlag(trigger.dataset.salesKitFor);
      location.hash = 'r-sales-kit';
      kit.scrollIntoView({ block: 'start', behavior: 'auto' });
      flag.focus({ preventScroll: true });
    });
    kit.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      const list = selected();
      if (busy || list.some(o => !o || o.disabled || o.dataset.preview === 'true')) return;
      busy = true;
      submit.disabled = true;
      submit.textContent = 'AJOUT EN COURS…';
      status.textContent = '';
      try {
        const items = list.map(o => ({ id: Number(o.value), quantity: 1 }));
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Disponibilité modifiée.');
        }
        window.location.assign(rootUrl + 'cart');
      } catch (error) {
        status.textContent = 'Ajout non confirmé. Vérifie ton panier avant de réessayer pour éviter un doublon. ';
        const link = document.createElement('a');
        link.href = rootUrl + 'cart'; link.textContent = 'Voir mon panier';
        status.appendChild(link);
        submit.textContent = 'VÉRIFIE TON PANIER';
      }
    });
  }

  const panel = document.querySelector('.main-product:not(.main-product--configurator) .product-panel, .rsd__panel');
  const form = panel?.querySelector('form[action*="/cart/add"]');
  const primary = form?.querySelector('button[type="submit"]');
  if (panel && form && primary) {
    const bar = document.createElement('div');
    bar.className = 'r-sales-sticky';
    const label = document.createElement('div');
    const amount = document.createElement('strong');
    const detail = document.createElement('small');
    detail.textContent = 'Options et quantité choisies sur la fiche';
    label.append(amount, detail);
    const button = document.createElement('button');
    button.type = 'button';
    bar.append(label, button);
    document.body.appendChild(bar);
    document.body.classList.add('r-sales-has-sticky');
    const priceNode = panel.querySelector('[data-product-price], .rsd__price');
    const sync = () => {
      amount.textContent = priceNode?.textContent.trim() || '';
      button.disabled = primary.disabled;
      button.textContent = primary.disabled ? 'INDISPONIBLE' : 'AJOUTER AU PANIER';
      const stock = panel.querySelector('[data-sales-stock]');
      if (stock) stock.textContent = primary.disabled ? 'Ce modèle est actuellement indisponible' : 'Modèle disponible à la commande';
      const help = panel.querySelector('[data-sales-availability-help]');
      if (help) help.hidden = !primary.disabled;
    };
    sync();
    new MutationObserver(sync).observe(primary, { attributes: true, childList: true, subtree: true });
    if (priceNode) new MutationObserver(sync).observe(priceNode, { childList: true, subtree: true, characterData: true });
    button.addEventListener('click', () => { if (!primary.disabled) form.requestSubmit(primary); });
  }
})();